import { styled, TableRow } from '@mui/material';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  height: '22px',
  paddingBottom: 8,
  verticalAlign: 'center',
  borderBottom: `0.5px solid ${theme.palette.gx.neutral}`,
  '&:last-child tr': { border: 0, borderBottom: 0 }
}));

export default StyledTableRow;
